import React from 'react';
import Time from 'react-time';
import ReactTooltip from 'react-tooltip';
import { AuthButton } from '../helptips/helptooltips';
import PropTypes from 'prop-types';

import AppStore from '../../stores/app-store';
import AppActions from '../../actions/app-actions';
import ScheduleDialog from '../deployments/fw/scheduledialog';
import AssignDialog from './assigndialog';
import Authsets from './authsets';
import Loader from '../common/loader';
import pluralize from 'pluralize';
import cookie from 'react-cookie';
import copy from 'copy-to-clipboard';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Divider from '@material-ui/core/Divider';
import Icon from '@material-ui/core/Icon';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Typography from '@material-ui/core/Typography';

import BlockIcon from '@material-ui/icons/Block';
import CheckIcon from '@material-ui/icons/Check';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import HelpIcon from '@material-ui/icons/Help';
// import LinkIcon from '@material-ui/icons/Link';
import ReplayIcon from '@material-ui/icons/Replay';
import WarningIcon from '@material-ui/icons/Warning';
//import ShowChartIcon from  '@material-ui/icons/ShowChartOutlined';

import { preformatWithRequestID, getUserRoleFromJWT } from '../../helpers';
import ConfigProvision from '../configurations/config-provision';
//import ExpandJsonView from '../configurations/expand-json-view';
import ExpandedAction from '../actions/expanded-action';
import ExpandedConfig from '../configurations/expanded-config';
import DeviceCharts from './device-charts';

import DeviceTimeLineStatus from './device-timeline-status';
import SlotAssociation from './slotAssociation';
import SlotInformation from './slot-information';
const iconStyle = { margin: 12 };

const states = {
  pending: {
    text: 'Accept or reject the device?',
    statusIcon: <Icon className="pending-icon" style={iconStyle} />
  },
  accepted: {
    text: 'Reject or decommission this device?',
    statusIcon: <CheckCircleIcon className="green" style={iconStyle} />
  },
  rejected: {
    text: 'Accept or decommission this device?',
    statusIcon: <BlockIcon className="red" style={iconStyle} />
  },
  preauthorized: {
    text: 'Remove this device from authorization?',
    statusIcon: <CheckIcon style={iconStyle} />
  }
};

export default class ExpandedDevice extends React.Component {
  static contextTypes = {
    router: PropTypes.object,
    location: PropTypes.object
  };

  constructor(props, context) {
    super(props, context);

    this.state = {
      artifacts: AppStore.getArtifactsRepo(),
      aiPackages: AppStore.getAiPackagesRepo(),
      authsets: false,
      docsVersion: AppStore.getDocsVersion(),
      schedule: false,
      assign: false,
      selectedGroup: {
        payload: '',
        text: ''
      },
      showHelptips: AppStore.showHelptips(),
      showInput: false,
      user: AppStore.getCurrentUser(),
      currentUserRole: getUserRoleFromJWT(),
      changeConfigDlg: false,
      deviceChartsDlg:false,
      deviceChartTittle:'',
      changeConfig: (this.props.device.status === 'accepted') ? this.getConfig() : {}
    };
  }

  componentDidMount() {
    this._getArtifacts();
    this._getAiPackages();
  }

  //Used to show info for config edit
  getConfig() {
    var cfg = {};
    cfg.type = this.props.device.configInfo.configuration.type || '';
    cfg.configName = this.props.device.configInfo.configuration.name || '';
    cfg.flavorName = this.props.device.configInfo.flavor.name || '';
    cfg.label = this.props.device.label || '';
    return cfg;
  }

  updateConfig = (device_id, auth_id, status, type, flavor_name, config_name, label) => {
    var self = this;
    self.toggleChangeConfigDlg(false);

    return AppActions.updateDeviceAuth(device_id, auth_id, status, type, flavor_name, config_name, label)
      .then(() => {
        // Update local state, to retain edited values
        let cfg = {};
        cfg.type = type;
        cfg.configName = config_name;
        cfg.flavorName = flavor_name;
        cfg.label = label;
        self.setState({ changeConfig: cfg });
        self.props.updateconfig(cfg);
      })
      .catch(err => console.log(`Error: ${err}`));
  }

  _getArtifacts() {
    var self = this;
    if (this.props.device.status === 'accepted') {
      AppActions.getArtifacts()
        .then(artifacts =>
          setTimeout(() => {
            self.setState({ artifacts });
          }, 300)
        )
        .catch(err => console.log(err.error || 'Please check your connection'));
    }
  }

  _getAiPackages() {
    var self = this;
    if (this.props.device.status === 'accepted') {
      AppActions.getAiPackages()
        .then(aiPackages =>
          setTimeout(() => {
            self.setState({ aiPackages });
          }, 300)
        )
        .catch(err => console.log(err.error || 'Please check your connection'));
    }
  }

  dialogToggle(ref) {
    var state = {};
    state[ref] = !this.state[ref];
    this.setState({ filterByArtifact: null });
  }

  toggleAuthsets(authsets = !this.state.authsets) {
    this.setState({ authsets });
    // this.props.pause();
    this.props.refreshDevices(true);
  }

  _updateParams(val, attr) {
    // updating params from child schedule form
    var tmp = {};
    tmp[attr] = val;
    this.setState(tmp);
  }

  _clickListItem() {
    AppActions.setSnackbar('');
    this.setState({ schedule: false });
  }

  _onScheduleSubmit(artifact) {
    var self = this;
    var newDeployment = {
      devices: [this.props.device.id],
      name: this.props.device.id,
      artifact_name: artifact.name
    };
    self.setState({ schedule: false });
    return AppActions.createDeployment(newDeployment)
      .then(data => {
        // get id, if showhelptips & no onboarded cookie, this is user's first deployment - add id cookie
        var lastslashindex = data.lastIndexOf('/');
        var id = data.substring(lastslashindex + 1);

        // onboarding
        if (self.state.showHelpTips && !cookie.load(`${self.state.user.id}-onboarded`) && !cookie.load(`${self.state.user.id}-deploymentID`)) {
          cookie.save(`${self.state.user.id}-deploymentID`, id);
        }

        AppActions.setSnackbar('Deployment created successfully. Redirecting...', 5000);
        setTimeout(() => {
          self.context.router.history.replace('/deployments');
        }, 1200);
      })
      .catch(err => {
        try {
          var errMsg = err.res.body.error || '';
          AppActions.setSnackbar(preformatWithRequestID(err.res, `Error creating deployment. ${errMsg}`), null, 'Copy to clipboard');
        } catch (e) {
          console.log(e);
        }
      });
  }

  _onAssignSubmit(aipackage) {
    var self = this;
    var data =
      {
        artifact_name: aipackage.name,
        name: this.props.device.id,
        devices: [this.props.device.id],
      };

    self.setState({ assign: false });

    return AppActions.createAiDeployment(data)
      .then(() => {
        AppActions.setSnackbar('AI package deployed successfully', 2000);
      })
      .catch(err => {
        var errMsg = err.res.error.message || '';
        console.log(errMsg);
        AppActions.setSnackbar(preformatWithRequestID(err.res, `There was a problem in deploying AI package to the device: ${errMsg}`), null, 'Copy to clipboard');
      })
      .finally(() => self.props.refreshDevices(true));
  }

  _handleStopProp(e) {
    e.stopPropagation();
  }

  _deploymentParams(val, attr) {
    // updating params from child schedule form
    var tmp = {};
    tmp[attr] = val;
    this.setState(tmp);

    // check that device type matches
    var filteredDevs = null;
    if (attr === 'artifact' && val) {
      const device_type = this.props.device.attributes.find(item => item.name === 'device_type').value;
      for (var i = 0; i < val.device_types_compatible.length; i++) {
        if (val.device_types_compatible[i] === device_type) {
          filteredDevs = [this.props.device];
          break;
        }
      }
    }
    this.setState({ filterByArtifact: filteredDevs });
  }
  _clickLink() {
    window.location.assign(`https://docs.mender.io/${this.state.docsVersion}/client-configuration/configuration-file/polling-intervals`);
  }
  _copyLinkToClipboard() {
    var location = window.location.href.substring(0, window.location.href.indexOf('/devices') + '/devices'.length);
    copy(`${location}/id=${this.props.device.id}`);
    AppActions.setSnackbar('Link copied to clipboard');
  }

  _decommissionDevice(device_id) {
    var self = this;
    return AppActions.decommissionDevice(device_id)
      .then(() => {
        // close dialog!
        self.toggleAuthsets(false);
        // close expanded device
        // trigger reset of list!
        AppActions.setSnackbar('Device was decommissioned successfully');
      })
      .catch(err => {
        var errMsg = err.res.error.message || '';
        console.log(errMsg);
        AppActions.setSnackbar(preformatWithRequestID(err.res, `There was a problem decommissioning the device: ${errMsg}`), null, 'Copy to clipboard');
      })
      .finally(() => self.props.refreshDevices(true));
  }

  toggleChangeConfigDlg(changeConfigDlg = !this.state.changeConfigDlg) {
    this.setState({ changeConfigDlg });
    // this.props.pause();
  }

  toggleDeviceChartsDlg(deviceChartsDlg = !this.state.deviceChartsDlg, deviceChartTittle) {
    this.setState({ deviceChartsDlg:deviceChartsDlg, deviceChartTittle:deviceChartTittle});
    // this.props.pause();
  }

  render() {
    var self = this;
    var status = this.props.device.status;

    var deviceIdentity = [];
    deviceIdentity.push(
      <div key="id_checksum">
        <ListItem classes={{ root: 'attributes', disabled: 'opaque' }} disabled={true}>
          <ListItemText primary="Device ID" secondary={(this.props.device || {}).id || '-'} />
        </ListItem>
        <Divider />
      </div>
    );

    if ((this.props.device || {}).identity_data) {
      var data = typeof this.props.device.identity_data == 'object' ? this.props.device.identity_data : JSON.parse(this.props.device.identity_data);
      deviceIdentity = Object.entries(data).reduce((accu, item) => {
        accu.push(
          <div key={item[0]}>
            <ListItem classes={{ root: 'attributes', disabled: 'opaque' }} disabled={true} >
              <ListItemText style={{ width: 'max-content' }} primary={item[0]} secondary={item[1]} />
            </ListItem>
            <Divider />
          </div>
        );

        return accu;
      }, deviceIdentity);
    }

    if ((this.props.device || {}).created_ts) {
      var createdTime = <Time value={this.props.device.created_ts} format="YYYY-MM-DD HH:mm" />;
      deviceIdentity.push(
        <div key="connectionTime">
          <ListItem classes={{ root: 'attributes', disabled: 'opaque' }} disabled={true}>
            <ListItemText primary={status === 'preauthorized' ? 'Date added' : 'First request'} secondary={createdTime} />
          </ListItem>
          <Divider />
        </div>
      );
    }

    var deviceInventory = [];
    var inventoryUpdatedTime = <Time value={this.props.device.updated_ts} format="YYYY-MM-DD HH:mm" />;
    var waiting = false;
    if (typeof this.props.attrs !== 'undefined' && this.props.attrs.length > 0) {
      var sortedAttributes = this.props.attrs.sort((a, b) => {
        return a.name.localeCompare(b.name);
      });
      for (var i = 0; i < sortedAttributes.length; i++) {
        var secondaryText = sortedAttributes[i].value instanceof Array ? sortedAttributes[i].value.toString() : sortedAttributes[i].value;
        deviceInventory.push(
          <div key={i}>
            <ListItem classes={{ root: 'attributes', disabled: 'opaque' }} disabled={true}>
              <ListItemText primary={sortedAttributes[i].name} secondary={secondaryText} />
            </ListItem>
            <Divider />
          </div>
        );
      }
    } else {
      waiting = true;
      deviceInventory.push(
        <div className="waiting-inventory" key="waiting-inventory">
          <ReactTooltip id="inventory-wait" globalEventOff="click" place="top" type="light" effect="solid" className="react-tooltip">
            <h3>Waiting for inventory data</h3>
            <p>Inventory data not yet received from the device - this can take up to 30 minutes with default installation.</p>
            <p>
              Also see the documentation for{' '}
              <a onClick={() => this._clickLink()} href="https://docs.mender.io/client-configuration/configuration-file/polling-intervals">
                Polling intervals
              </a>
              .
            </p>
          </ReactTooltip>

          <p>Waiting for inventory data from the device</p>
          <Loader show={true} waiting={true} />
        </div>
      );
    }

    var deviceInventory2 = [];
    if (deviceInventory.length > deviceIdentity.length) {
      deviceInventory2 = deviceInventory.splice(deviceInventory.length / 2 + (deviceInventory.length % 2), deviceInventory.length);
    }

    const statusIcon = states[status].statusIcon;

    var hasPending = '';
    if (status === 'accepted' && this.props.device.auth_sets.length > 1) {
      hasPending = this.props.device.auth_sets.reduce((accu, set) => {
        return set.status === 'pending' ? 'This device has a unauthorized authentication set' : accu;
      }, '');
    }

    const authLabelText = hasPending ? hasPending : states[status].text || states.default.text;

    const buttonStyle = { textTransform: 'none', textAlign: 'left' };

    var deviceInfo = (
      <div key="deviceinfo">
        <div className="device-identity bordered">
          <div className="margin-bottom-small">
            <h4 className="margin-bottom-none">Device Identity</h4>
            <List className="list-horizontal-flex-di">{deviceIdentity}</List>
          </div>

          <div className="margin-bottom-small flexbox" style={{ flexDirection: 'row' }}>
            <span style={{ display: 'flex', minWidth: 180, flexBasis: '315px', alignItems: 'center' }}>
              {statusIcon}
              <span className="inline-block">
                <Typography component="span" variant="subtitle2" style={Object.assign({}, buttonStyle, { textTransform: 'capitalize' })}>
                  Device status
                </Typography>
                <Typography component="caption" variant="subtitle1" style={Object.assign({}, buttonStyle, { textTransform: 'capitalize' })}>
                  {status}
                </Typography>
              </span>
            </span>

            <Button disabled = { this.state.currentUserRole !== 'admin'} style={{ width: '25em' }}
              onClick={() => {
                this.toggleAuthsets(true);
                AppActions.setSnackbar('');
              }}
            >
              {hasPending ? <WarningIcon className="auth" /> : null}
              <span className="inline-block">
                <Typography component="span" variant="subtitle1" style={buttonStyle}>
                  {authLabelText}
                </Typography>
                <Typography variant="caption" display="block" className="muted" style={buttonStyle}>
                  Click to adjust authorization status for this device
                </Typography>
              </span>
            </Button>
            {status === 'accepted' ? (
              <Button disabled = { this.state.currentUserRole !== 'admin'} style={{ width: '25em' }}
                onClick={() => {
                  this.toggleChangeConfigDlg(true);
                  AppActions.setSnackbar('');
                }}
              >
                <span className="inline-block">
                  <Typography component="span" variant="subtitle1" style={buttonStyle}>
                    Change Config
                  </Typography>
                  <Typography variant="caption" display="block" className="muted" style={buttonStyle}>
                    Click to change Configuration/Flavor for this device
                  </Typography>
                </span>
              </Button>
            ) : null}
          </div>
        </div>
        {status === 'accepted' ? (
          <div className="device-config bordered">
            <DeviceTimeLineStatus {...this.props} />
          </div>
        ) : null}

        {status === 'accepted' ? (
          <div className="device-config bordered">
            <div className="margin-bottom-small">
              <h4 className="margin-bottom-none">Device Configuration</h4>
            </div>
            <ExpandedConfig
              {...self.props}
              configName={this.state.changeConfig.configName}
              flavorName={this.state.changeConfig.flavorName}
            />
          </div>
        ) : null}

        {status === 'accepted' ? (
          <div className="device-action bordered">
            <div className="margin-bottom-small">
              <h4 className="margin-bottom-none">Device Alarms & Actions</h4>
            </div>
            <ExpandedAction
              {...self.props}
              device={this.props.device}
            />
          </div>
        ) : null}

        {this.props.attrs || status === 'accepted' ? (
          <div className="device-inventory bordered">
            <div className={this.props.unauthorized ? 'hidden' : 'report-list'}>
              <h4 className="margin-bottom-none">Device Inventory ( {inventoryUpdatedTime} )</h4>
              <List>{deviceInventory}</List>
            </div>

            <div className={this.props.unauthorized ? 'hidden' : 'report-list'}>
              <List style={{ marginTop: '34px' }}>{deviceInventory2}</List>
            </div>
          </div>
        ) : null}

        {status === 'accepted' && !waiting ? (
          <div className="device-actions" style={{ marginTop: '24px' }}>
            {/* <Button onClick={() => this._copyLinkToClipboard()}>
              <LinkIcon className="rotated buttonLabelIcon" />
              Copy link to this device
            </Button> */}
            {status === 'accepted' ? (
              <span className="margin-left">
                <Button disabled = { this.state.currentUserRole !== 'admin'} onClick={() => this.setState({ schedule: true })}>
                  <ReplayIcon className="rotated buttonLabelIcon" />
                  Create a deployment for this device
                </Button>
              </span>
            ) : null}
            {status === 'accepted' ? (
              <span className="margin-left">
                <Button disabled = { this.state.currentUserRole !== 'admin'} onClick={() => this.setState({ assign: true })}>
                  <ReplayIcon className="rotated buttonLabelIcon" />
                  Deploy an AI Package for this device
                </Button>
              </span>
            ) : null}
            {
              this.state.currentUserRole === 'admin'
                ? (<SlotAssociation device={this.props.device}
                  basicInstall={this.props.basicInstall} updateBasicInstall={this.props.updateBasicInstall}/>)
                : null
            }
            <SlotInformation basicInstall={this.props.basicInstall} />
          </div>
        ) : null}
      </div>
    );

    var authsetActions = [
      <Button key="authset-button-1" style={{ marginRight: '10px', display: 'inline-block' }} onClick={() => this.toggleAuthsets(false)}>
        Close
      </Button>
    ];
    var changeConfigDlgTitle = 'Change Configuration for this device';

    var authsetTitle = (
      <div style={{ width: 'fit-content', position: 'relative' }}>
        {this.props.device.status === 'pending'
          ? `Authorization ${pluralize('request', this.props.device.auth_sets.length)} for this device`
          : 'Authorization status for this device'}
        <ReactTooltip id="inventory-wait" globalEventOff="click" place="bottom" type="light" effect="solid" className="react-tooltip">
          <h3>Device authorization status</h3>
          <p>
            Each device sends an authentication request containing its identity attributes and its current public key. You can accept, reject or dismiss these
            requests to determine the authorization status of the device.
          </p>
          <p>
            In cases such as key rotation, each device may have more than one identity/key combination listed. See the documentation for more on{' '}
            <a onClick={() => this._clickLink()} href="https://docs.mender.io/architecture/device-authentication">
              Device authentication
            </a>
            .
          </p>
        </ReactTooltip>
      </div>
    );

    return (
      <div className={this.props.className}>
        {deviceInfo}

        {this.state.showHelptips && status === 'pending' ? (
          <div>
            <div
              id="onboard-4"
              className={this.props.highlightHelp ? 'tooltip help highlight' : 'tooltip help'}
              data-tip
              data-for="auth-button-tip"
              data-event="click focus"
              style={{ left: '580px', top: '178px' }}
            >
              <HelpIcon />
            </div>
            <ReactTooltip id="auth-button-tip" globalEventOff="click" place="bottom" type="light" effect="solid" className="react-tooltip">
              <AuthButton devices={[this.props.device]} />
            </ReactTooltip>
          </div>
        ) : null}

        <ScheduleDialog
          open={this.state.schedule}
          deploymentDevices={[this.props.device]}
          filteredDevices={this.state.filterByArtifact}
          deploymentSettings={(...args) => this._deploymentParams(...args)}
          artifacts={this.state.artifacts}
          device={this.props.device}
          groups={this.props.groups}
          onDismiss={() => this.setState({ schedule: false })}
          onScheduleSubmit={(_group, _devices, artifact) => this._onScheduleSubmit(artifact)}
        />

        <AssignDialog
          open={this.state.assign}
          deploymentDevices={[this.props.device]}
          filteredDevices={this.state.filterByArtifact}
          deploymentSettings={(...args) => this._deploymentParams(...args)}
          artifacts={this.state.aiPackages}
          device={this.props.device}
          groups={this.props.groups}
          onDismiss={() => this.setState({ assign: false })}
          onAssignSubmit={(_group, _devices, aiPackage) => this._onAssignSubmit(aiPackage)}
        />

        <Dialog
          open={this.state.authsets}
          fullWidth={true}
          maxWidth="lg"
          style={{
            paddingTop: '0',
            fontSize: '13px',
            overflow: 'hidden'
          }}
        >
          <DialogTitle>{authsetTitle}</DialogTitle>
          <DialogContent>
            <Authsets
              dialogToggle={() => this.toggleAuthsets(false)}
              decommission={id => this._decommissionDevice(id)}
              device={this.props.device}
              id_attribute={this.props.id_attribute}
              id_value={this.props.id_value}
              limitMaxed={this.props.limitMaxed}
            />
          </DialogContent>
          <DialogActions>{authsetActions}</DialogActions>
        </Dialog>
        <Dialog
          open={this.state.changeConfigDlg}
          maxWidth="lg"
          style={{
            paddingTop: '0',
            fontSize: '13px',
            overflow: 'hidden'
          }}
        >
          <DialogTitle>{changeConfigDlgTitle}</DialogTitle>
          <DialogContent>
            <ConfigProvision
              dialogToggle={() => this.toggleChangeConfigDlg(false)}
              device={this.props.device}
              id_attribute={this.props.id_attribute}
              id_value={this.props.id_value}
              confirm={this.updateConfig}
              config={this.state.changeConfig}
              provision={false}
            />
          </DialogContent>
        </Dialog>
        <Dialog
          open={this.state.deviceChartsDlg}
          style={{
            paddingTop: '0',
            fontSize: '13px',
          }}
        >
          <div style={{height: 370, width: 600}} >
            <DialogTitle>{this.state.deviceChartTittle}</DialogTitle>
            <DialogContent>
              <DeviceCharts
                device={this.props.device}
                id_attribute={this.props.id_attribute}
                id_value={this.props.id_value}
                chartData={this.state.deviceChartTittle}
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={() => this.toggleDeviceChartsDlg(false)} color="primary">
                Close
              </Button>
            </DialogActions>
          </div>
        </Dialog>
      </div>
    );
  }
}
